import React, { useEffect } from "react";
import { useForm, useFormContext } from "react-hook-form";

import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogTextAreaControlledNew from "@/main/components/shared/textArea/textArea";

import Button from "@/main/components/shared/button/button";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { KeyValueDefault } from "@/main/models/common";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { useReasonReducer } from "@/main/store/reason";

import { ICreateAnswerForm } from "../../interfaceCreateAnswer";
import * as S from "./styles";

interface IModalNotQuoteSubmitProps {
	isOpenModal: boolean;
	handleSave: (data: ICreateAnswerForm) => void;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
}
const INITIAL_FORM_STATE = {
	reason: null as KeyValueDefault | null,
	observation: "" as string,
};
export type InitialFormStateType = typeof INITIAL_FORM_STATE;
function WrapperModalNotQuoteSubmit({ closeModal, handleSave }: IModalNotQuoteSubmitProps) {
	const { reason: reasonReducer } = useReasonReducer();

	const { control, handleSubmit, setValue, watch } = useForm<InitialFormStateType>({
		defaultValues: INITIAL_FORM_STATE,
	});
	const methodsGrid = useFormContext<ICreateAnswerForm>();
	const watcherReason = watch("reason");

	function handleAnswer(data: InitialFormStateType) {
		const pending = methodsGrid.getValues("pendingItems");
		const answered = methodsGrid.getValues("answeredItems");

		const updatedPending = pending.map((item) => {
			if (item.notQuote && item.reason) return item;

			if (item.isGroupHidden) {
				return {
					...item,
					notQuote: true,
					reason: data.reason,
					observation: data.observation,
					isGroupHidden: false,
				};
			}

			const isInvalid = !item.notQuote && !item.answeredPrice;
			if (isInvalid) {
				return {
					...item,
					notQuote: true,
					reason: data.reason,
					observation: data.observation,
				};
			}

			return item;
		});

		methodsGrid.reset({
			pendingItems: updatedPending,
			answeredItems: answered,
		});
		handleSave({ pendingItems: updatedPending, answeredItems: answered });
		closeModal();
	}

	function handleCancel(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();

		// methodsGrid.handleSubmit(() => { })();
		closeModal();
	}

	useEffect(() => {
		if (isNullUndefined(reasonReducer.data)) return;

		const defaultValueReason = reasonReducer.data.find(
			(item) => item.value === getTranslateByKey("reason.quoteChangeStatusNoSupplierAvaible"),
		);
		if (isNullUndefined(defaultValueReason)) return;

		setValue("reason", defaultValueReason);
	}, []);

	const isDisabledObservation = () => convertStringForBoolean(watcherReason?.default);

	return (
		<form onSubmit={handleSubmit(handleAnswer)} noValidate>
			<S.Container>
				<S.Text>{getTranslateByKey("information.modalNotQuoteAnswer")}.</S.Text>
				<KogAutoCompleteControlled
					className="ignore-click"
					id="id-createAnswer-text-reason-submit"
					required
					label={getTranslateByKey("information.reason")}
					nameCustom="reason"
					control={control}
					setValueCustom={setValue}
					options={reasonReducer.data}
					isLoading={reasonReducer.isLoading}
					rulesCustom={{ required: true }}
					onChangeCustom={() => {}}
				/>
				{isDisabledObservation() && (
					<KogTextAreaControlledNew
						id="id-createAnswer-text-observation-submit"
						name="observation"
						required
						control={control}
						autoFocus
						rulesCustom={{ required: isDisabledObservation() }}
						label={getTranslateByKey("information.observation")}
					/>
				)}

				<S.AreaButtons>
					<Button id="id-createAnswer-btn-answer-submit" type="submit">
						{getTranslateByKey("information.answer")}
					</Button>
					<SecondaryButton id="id-createAnswer-btn-cancel-submit" type="button" onClick={handleCancel}>
						{getTranslateByKey("information.cancel")}
					</SecondaryButton>
				</S.AreaButtons>
			</S.Container>
		</form>
	);
}

function ModalNotQuoteSubmit(props: IModalNotQuoteSubmitProps) {
	return (
		<KogModalFadeComponent isInModal closeByOverlay={false} open={props.isOpenModal} setOpen={props.setIsOpenModal}>
			<WrapperModalNotQuoteSubmit {...props} />
		</KogModalFadeComponent>
	);
}

export default ModalNotQuoteSubmit;
